// @flow
import * as React from "react";
import styled from "styled-components";
import { rtl, fontSize } from "../common/styled-mixins";
import { InfoIcon } from "./Icons";

const Info = styled.div`
  direction: ${({ theme }) => theme.direction};
  position: relative;
  flex: 1 1 auto;
  ${rtl("padding-left", "23px")};
  font-size: ${fontSize(12, 16)};
  line-height: 1.25;
  ${rtl("text-align", "left")};
  color: #99959d;
  white-space: normal;

  @media (max-width: 959px) {
    margin-right: 22px;
  }

  @media (max-width: 479px) {
    flex-basis: 100%;
    flex-shrink: 0;
    width: 100%;
    margin-right: 0;
  }
`;

const IconContainer = styled.span`
  position: absolute;
  ${rtl("left", 0)};
  top: -2.5px;
`;

const AccountInfo = ({ children }: { children: React.Node }) => (
  <Info>
    <IconContainer>
      <InfoIcon />
    </IconContainer>{" "}
    {children}
  </Info>
);

export default AccountInfo;



// WEBPACK FOOTER //
// ./src/components/AccountType/AccountInfo.js